<template>
  <div>
    <c-tab
      type="vertical"
      :height.sync="tabHeight"
      :tabItems="tabItems"
      v-model="tab"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :param="popupParam"
          :planUpdateBtnData="popupParam.planUpdateBtnData"
          :educationInfo.sync="educationInfo"
          @setData="setData"
        />
      </template>
    </c-tab>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
import transactionConfig from "@/js/transactionConfig";
export default {
  name: "education-result-appr",
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        eduEducationId: "",
        planUpdateBtnData: {
          title: "LBLPLAN",
          flag: false,
          research: "",
          planResearch: "",
        },
      }),
    },
    height: {
      type: String,
      default: function () {
        return "";
      },
    },
  },
  data() {
    return {
      educationInfo: {
        eduEducationId: "",
        educationName: "",
        eduCourseId: "",
        plantCd: "",
        educationCourseName: "",
        educationKindCdLarge: null,
        educationKindCdSmall: null,
        educationTypeCd: null,
        departmentDeptCd: "",
        departmentDeptName: "",
        executionBudget: "",
        estimatedEducationExpenses: "",
        educationMethodName: "",
        educationMethodCd: null,
        educationOverview: "",
        evaluationEvalCd: null,
        documentStatusCd: "",
        qrCodeRoute: "",

        regUserId: "",
        chgUserId: "",
        eduSubjectList: [], // 과정별 교육과목
        eduAttendeeList: [],
        eduEvalUserList: [],
        deleteEduEvalUserList: [],

        eduQuestionFlag: "N",
        eduQuestionMstId: "",
        eduQuestionPassScore: 0,
      },
      completeUrl: "",
      editable: true,
      splitter: 5,
      tab: "educationResultInfo",
      printResultUrl: "",
      printResultUserUrl: "",
      getUrl: "",
      updateUrl: "",
      isApproval: false,
    };
  },
  computed: {
    approvalInfo() {
      return {
        sysApprovalRequestId: this.educationInfo.sysApprovalRequestId, // 결재요청번호
        /**
         * 결재상태코드
         * ASC0000001	결재중
         * ASC0000002	반려
         * ASC9999999	결재완료
         */
        approvalStatusCd: this.educationInfo.approvalStatusCd,
        apprEditable:
          this.educationInfo.approvalStatusCd === null ||
          this.educationInfo.approvalStatusCd == "ASC0000001", // 결재버튼 활성화 기준
        param: this.educationInfo, // 결재 param
        approvalUrl: this.updateUrl, // 결재 url
        isApproval: this.isApproval, // 결재 submit
        approvalTypeCd: "APTC000015", // 결재유형코드
        approvalParamValue: {
          // 결재상세화면 파라미터
          envWaterEntrustResultId: this.popupParam.eduEducationId,
          plantCd: this.popupParam.plantCd,
          isFullScreen: false,
        },
        approvalRequestName:
          "교육결과 [" + this.educationInfo.educationName + "]", // 결재요청명 (문서 title)
        approvalConnId: this.popupParam.eduEducationId, // 결재연결용 업무일련번호 (문서 key)
      };
    },
    tabHeight() {
      let numHeight = this.height
        ? Number(this.$_.replace(this.height, "px", ""))
        : 600;
      numHeight = numHeight - 40;
      return numHeight + "px";
    },
    disabled() {
      return this.educationInfo.documentStatusCd === "ESC000010";
    },
    tabItems() {
      return [
        // 기본정보
        {
          name: "educationResultInfo",
          icon: "edit",
          label: "LBLBASEINFO",
          component: () =>
            import(`${"@/pages/sop/edu/result/educationResultInfo.vue"}`),
        },
        // 교육이수
        {
          name: "educationComplete",
          icon: "how_to_reg",
          label: "LBL0002903",
          component: () =>
            import(`${"@/pages/sop/edu/result/educationComplete.vue"}`),
        },
      ];
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      this.editable = this.$route.meta.editable;

      this.getUrl = selectConfig.sop.edu.result.get.url;
      this.updateUrl = transactionConfig.sop.edu.result.update.url;
      this.completeUrl = transactionConfig.sop.edu.result.complete.url;
      this.printResultUrl = selectConfig.sop.edu.result.print.result.url;
      this.printResultUserUrl =
        selectConfig.sop.edu.result.print.targetUser.url;
      // list setting
      this.getDetail();
    },
    getDetail() {
      if (this.popupParam.eduEducationId) {
        this.$http.url = this.$format(
          this.getUrl,
          this.popupParam.eduEducationId,
        );
        this.$http.type = "GET";
        this.$http.request((_result) => {
          this.educationInfo = _result.data;
        });
      }
    },
    setData(data) {
      this.popupParam.eduEducationId = data;
      this.getDetail();
    },
    saveDataAppr() {
      window.getApp.$emit("CONFIRM", {
        title: "확인",
        message: "결재요청 하기 전 입력된 값을 저장합니다.\n진행하시겠습니까?",
        // TODO : 필요시 추가하세요.
        type: "info", // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.educationInfo.regUserId = this.$store.getters.user.userId;
          this.educationInfo.chgUserId = this.$store.getters.user.userId;
          let promises = [
            {
              func: this.approvalValue,
            },
          ];
          this.$comm.orderedPromise(promises);
        },
        // 취소 callback 함수
        cancelCallback: () => {},
      });
    },
    // [S] 결재관련
    approvalCallback() {
      // 결재관련 결재요청버튼 callback
      this.$refs["appr-btn"].apprRequestPop();
    },
    approvalValue() {
      return new Promise((resolve) => {
        this.isApproval = !this.isApproval;
        resolve(true);
      });
    },
  },
};
</script>
